import { ApolloClient, HttpLink } from '@apollo/client';
import { clearUserSessionData } from '../session';
import cache from './cache';
import { getSessionId } from './sessionHeader';
import { getLanguageForApi } from '../util/getLanguageForApi';
import { getOrCreateAnonymousId } from '../anonymousId';
import { webApiUrl } from './apiUtils';

async function customFetch(input: RequestInfo, init?: RequestInit) {
  // the shop and api can live on different registrable domains (fitracking, per-dev staging), where
  // the ajs_anonymous_id cookie cannot follow; the server reads this query param before the cookie.
  if (typeof input === 'string') {
    input = `${input}${input.includes('?') ? '&' : '?'}anonymousId=${encodeURIComponent(getOrCreateAnonymousId())}`;
  }

  const headers = new Headers(init?.headers);
  headers.set('x-locale-region', getLanguageForApi());

  const sid = getSessionId();
  if (sid) {
    headers.set('x-session-id', sid);
  }

  init = { ...init, headers };

  const response = await fetch(input, init);

  // We only use Apollo when we know the user is logged in. If we've made a GQL request and we get a 401 response,
  // that means we thought the user was authenticated but the user's session has expired. We should clear the
  // stored user session data in this case so the site will behave as if the user is logged out.
  if (response.status === 401) {
    clearUserSessionData();
  }

  return response;
}

const link = new HttpLink({
  uri: `${webApiUrl}/graphql`,
  credentials: 'include',
  fetch: customFetch,
});

const client = new ApolloClient({
  cache,
  link,
});

export default client;
